var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"pills":"","card":"","vertical":"","nav-wrapper-class":"w-25"}},[_c('b-tab',{attrs:{"title":"Absensi Kedatangan"}},[_c('TabAbsensiKedatangan',{attrs:{"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }